import { BaseException } from 'exceptions/baseException';

export class ForbiddenException extends BaseException {
  static status = 403;

  constructor(message?: string) {
    super(message, ForbiddenException.status);
  }
}
